import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './shared/page/page.component';
import { HomeComponent } from './pages/home/home.component';
import { RoomsComponent } from './pages/home/rooms/rooms.component';
import { TestimonialsComponent } from './pages/home/testimonials/testimonials.component';
import { AmenitiesComponent } from './pages/home/amenities/amenities.component';
import { AttractionsComponent } from './pages/home/attractions/attractions.component';
import { LocationComponent } from './pages/home/location/location.component';
import { GalleryComponent } from './pages/gallery/gallery.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'room', component: RoomsComponent },
  { path: 'testimonials', component: TestimonialsComponent },
  { path: 'amenities', component: AmenitiesComponent },
  { path: 'attractions', component: AttractionsComponent },
  { path: 'location', component: LocationComponent },
  { path: 'gallery', component: GalleryComponent},
  {
    path: '',
    component: PageComponent,
    children: [
      {
        path: 'list',
        loadChildren: () => import('./listing/listing.module').then(m => m.ListingModule)
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'booking',
        loadChildren: () =>
          import('./site/booking/booking.module').then((m) => m.BookingModule),
      },
      {
        path: "menu",
        loadChildren: () =>
          import("./pages/shop/shop.module").then((m) => m.ShopModule),
      },


    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],

  exports: [RouterModule],
})
export class AppRoutingModule {}
